"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCloseOnClickOutside = void 0;
var React = __importStar(require("react"));
var useCloseOnClickOutside = function (_a) {
    var ref = _a.ref, onClose = _a.onClose, _b = _a.skip, skip = _b === void 0 ? false : _b;
    var handleOutsideClick = React.useCallback(function (event) {
        if (skip)
            return;
        if (ref.current && !ref.current.contains(event.target)) {
            onClose(event);
        }
    }, [ref, onClose, skip]);
    React.useEffect(function () {
        // add when mounted
        document.addEventListener('click', handleOutsideClick);
        return function () {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [handleOutsideClick]);
};
exports.useCloseOnClickOutside = useCloseOnClickOutside;
//# sourceMappingURL=useCloseOnClickOutside.js.map